import { Prefix, SearchType } from '@/types'

export interface BibliographyRealDetailBibliographyContent {
  prefix: Prefix
  bibliographyId: number
  searchType: SearchType
  displayTitle: string
  displayAuthor: string
  bibliographyRealId: number
}

export function BibliographyRealDetailBibliographyContentFromJSON(
  json: any
): BibliographyRealDetailBibliographyContent {
  return {
    prefix: json.prefix,
    bibliographyId: json.bibliography_id,
    searchType: json.search_type,
    displayTitle: json.display_title,
    displayAuthor: json.display_author,
    bibliographyRealId: json.bibliography_real_id
  }
}

export const defaultBibliographyRealDetailBibliographyContent = (): BibliographyRealDetailBibliographyContent => ({
  prefix: Prefix.Real,
  bibliographyId: 0,
  searchType: SearchType.Book,
  displayTitle: '',
  displayAuthor: '',
  bibliographyRealId: 0
})
